import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import css from '../../../css/css-variables.json';
import dismissIcon from '../../../img/sprite/x-icon.svg';

const Container = styled.div`
  border: 1px solid;
  margin: 10px 0;
  padding: 15px;
  width: 100%;
  border-radius: 4px;
  ${props => props.colors}
`;

const DismissButton = styled.button`
  float: right;
  border: 0 none;
  background-color: transparent;

  display: flex;

  margin-top: -1.5em;
  margin-right: -0.5em;
  padding: .5em;
  border-radius: 50%;
  transition: all .25s ease;

  &:hover {
    background-color: rgba(34, 34, 34, .15);
  }

  & svg {
    width: 10px;
    height: 10px;
  }
`;
DismissButton.displayName = 'DismissButton';

const MessageText = styled.div`
  padding: 0;
  margin: 0;
`;
MessageText.displayName = 'MessageText';

const MessageBanner = ({ error, message, children, type = 'message', className, clearBanner }) => {
  const hideBanner = () => clearBanner();
  const messageType = error ? 'error' : type;

  let colors;

  switch (messageType) {
    case 'success':
      colors = `
        color: #55884a;
        background-color: #d9eece;
        border-color: #bed0b4;
      `;
      break;
    case 'blue':
      colors = `
        color: #264888;
        background-color: #D9EDF7;
        border-color: #FFFFFF;
        `;
        break;
    case 'error':
      colors = `
        color: #b54a42;
        background-color: #f3dddf;
        border-color: #ebccd1;
      `;
      break;

    case 'warning':
      colors = `
        color: #7A7070};
        background-color: ${css.colors.Warning};
        border-color: ${css.colors.Warning};
      `;
      break;
    case 'plain':
      colors = `
        border-color: #e0e0e0;
        background-color: #fbfbfb;
        color: #66757f;
      `;
      break;
    default:
      colors = `
        color: #5690da;
        background-color: #daecf8;
        border-color: #bbdef2;
      `;
  }

  return (
    <React.Fragment>
      {(message || children) &&
        <Container id="messageBanner" colors={colors} className={className}>
          <MessageText data-qa-hook="banner.txt">
            {message}
            {children}
          </MessageText>
          {clearBanner &&
            <DismissButton onClick={hideBanner} aria-label="Dismiss Banner">
              <svg role="img"><use href={`#${dismissIcon.id}`} /></svg>
            </DismissButton>
          }
        </Container>
      }
    </React.Fragment>
  );

};

const { bool, string, node, func } = PropTypes;

MessageBanner.propTypes = {
  error: bool,
  message: string,
  children: node,
  type: string,
  className: string,
  clearBanner: func
};

export default MessageBanner;
